export const NAV_BUTTON_BASE_CLASSES =
  'h-7 w-7 flex items-center justify-center rounded-md border border-base-input shadow-none opacity-50 hover:opacity-100 transition-opacity';
export const NAV_BUTTON_DISABLED_CLASSES =
  'opacity-30 cursor-not-allowed hover:opacity-30';

export const MONTH_CELL_BASE_CLASSES =
  'h-9 px-3 font-normal text-sm rounded-md text-base-foreground transition-colors';
export const MONTH_CELL_HOVER_CLASSES = 'hover:bg-base-accent';
export const MONTH_CELL_SELECTED_CLASSES =
  'bg-indigo-600 text-white hover:bg-indigo-600 hover:text-white focus:bg-indigo-600 focus:text-white';
export const MONTH_CELL_CURRENT_CLASSES = 'text-base-foreground bg-base-accent';
export const MONTH_CELL_DISABLED_CLASSES =
  'text-base-mutedForeground opacity-50 cursor-not-allowed hover:bg-transparent';
